import  { useState, useEffect } from "react";

function useSecuity(){
    const [security,setSecurity]=useState({});
    const [userEmail,setUserEmail]=useState("");
    const [idToken,setIdToken]=useState("");
    const [isSecurityLoading,setIsSecurityLoading]=useState(false);
    const apiDomain=(process.env.NODE_ENV!=="development"?"/api":"http://"+window.location.hostname+":9000/api")
    useEffect(()=>{
        if(userEmail!==""){
            getSecurity();
        }
      },[userEmail])

    const getSecurity=()=>{
        setIsSecurityLoading(true);
        if(idToken===""){return}
        const params=`/members/security/${userEmail}`;
        fetch(apiDomain+params,{"headers":{"id_token":idToken}})
        .then(res => res.text())
        .then(res => {
            setIsSecurityLoading(false);
            const response=JSON.parse(res);
            if(response.data){
                console.log("Got security: "+response.data);
                setSecurity(response.data);
            }
        } )
        .catch((error)=>{
            console.log("error with API call");
            console.log(error);
            setIsSecurityLoading(false);
        });
    }
    const setSecurityUser=((newVal)=>{
        setUserEmail(newVal);
    })
    const setSecurityIdToken=((newVal)=>{
        setIdToken(newVal);
    })

    return {security,setSecurityUser,isSecurityLoading,setSecurityIdToken}
}

export default useSecuity;